module.exports = new __parcel__URL__("blanche-frankel.8cf2a89a.jpeg").toString();